<template>
    <div id="splash-screen" v-bind:class="{ shown: isShown }">

        <div v-if="shownItem" class="splash-item">
            <div class="image">
                <iframe :src="shownItem.image" frameborder="0"></iframe>
            </div>
            <div class="text" v-if="shownItem.text">
                <h2>{{shownItem.text}}</h2>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'Splash',
        data() {
            return {
                isShown: false,
                shownItem: null,
                items: [
                    {
                        time: {
                            everyday: true,
                            start: {
                                hour: 12,
                                minute: 30,
                            },
                            duration: (60 * 60)
                        },
                        images: [
                            "https://giphy.com/embed/6G1BhuIWyVEhG",
                            "https://giphy.com/embed/EKUvB9uFnm2Xe",
                            "https://giphy.com/embed/qtAy4ycRtxfeU",
                        ],
                        texts: [
                            "C'est l'heure de mangeeerrr",
                        ]
                    },
                ]
            }
        },
        methods: {
            displayItem(item) {

                var shownItem = {};
                shownItem.image = item.images[Math.floor(Math.random() * item.images.length)];
                shownItem.text = null;
                if (item.texts.length > 0) {
                    shownItem.text = item.texts[Math.floor(Math.random() * item.texts.length)];
                }
                return shownItem;
            },
            checkDisplay() {
                var foundItem = null;
                var now = Date.now();
                var elementDate = new Date();

                this.items.forEach(element => {
                    elementDate.setHours(element.time.start.hour, element.time.start.minute);
                    if (foundItem == null && element.time.everyday) {
                        if (now >= elementDate.getTime() && now < elementDate.getTime() + (element.time.duration * 1000)) {
                            foundItem = element;
                        }
                    }
                });

                if (foundItem != null) {
                    this.isShown = true;
                    this.shownItem = this.displayItem(this.items[0]);
                } else {
                    this.isShown = false;
                    this.shownItem = null;
                }
            },
        },
        created() {
            this.checkDisplay();
            setInterval(() => this.checkDisplay(), 10 * 1000);
        }
    }
</script>


<style scoped lang="less">

    #splash-screen {
        display: none;
        transition: opacity 1s ease-out;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        z-index: 98;
        overflow: hidden;

        &.shown {
            opacity: 1;
            display: block;
        }

        .splash-item {
            width: 100%;
            height: 100%;

            .image {
                width: 100%;
                height: 100%;

                iframe {
                    width: 100%;
                    height: 100%;
                }
            }

            .text h2 {
                z-index: 99;
                color: #fff;
                font-size: 50pt;
                position: absolute;
                bottom: 10%;
                width: 100%;
                text-align: center;
                text-transform: uppercase;
                font-weight: 600;
                text-shadow: 2px 0 0 #000, -2px 0 0 #000, 0 2px 0 #000, 0 -2px 0 #000, 1px 1px #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000;
            }
        }
    }


</style>
